var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('DataGetter',{attrs:{"url":`${_vm.apiRoute}/dashboard`,"params":{
      region: _vm.selectedRegion,
      product: 'Renewable electricity',
      flow: _vm.indicatorFlows,
    },"childElementType":null,"initialData":_vm.indicatorFlows.reduce((flows, flow) => {
        if (flow === 'Forecast revision' || flow === 'VRE phase') {
          flows.push({ flow, value: 0, unit: '%' });
        } else {
          flows.push({ flow, value: 0, year: 2022, unit: '%' });
          flows.push({ flow, value: 0, year: 2028, unit: '%' });
        }
        return flows;
      }, [])},scopedSlots:_vm._u([{key:"default",fn:function({ data }){return [_c('IndicatorBox',{attrs:{"title":`Key electricity indicators, ${_vm.selectedRegion}`,"indicators":data
          .toSorted(
            (a, b) =>
              _vm.indicatorFlows.indexOf(a.flow) - _vm.indicatorFlows.indexOf(b.flow)
          )
          .map((row) => {
            const invalid = !row.value || row.value.includes('Not');
            return {
              title:
                row.flow === 'Forecast revision'
                  ? 'Forecast revision from Renewables 2022'
                  : `${row.flow}, ${row.year}`,
              number: invalid
                ? undefined
                : parseFloat(parseFloat(row.value).toFixed(0)),
              invalid,
              units: row.unit === '%' ? row.unit : null,
              text: row.flow === 'VRE phase' && !invalid ? 'Phase ' : null,
              description:
                typeof row.value === 'string' && row.value.includes('Not')
                  ? row.value
                  : row.unit !== '%'
                  ? row.unit
                  : row.year === 2028
                  ? 'Forecast'
                  : null,
              arrow: row.flow === 'Forecast revision',
              info: _vm.indicatorNotes[row.flow],
            };
          }),"notes":_vm.countryNotes[_vm.selectedRegion],"compact":""}})]}}])}),_c('DataGetter',{attrs:{"url":`${_vm.apiRoute}/dashboard`,"params":{
      publication: _vm.publication,
      region: _vm.selectedRegion,
      flow: 'TARGETQUALIFIER',
    }},on:{"fetched":(data) => (_vm.targetText = data.length > 0 ? data[0].value : '')}}),_c('DataGetter',{staticClass:"container",attrs:{"url":_vm.endpoint,"params":{
      region: _vm.selectedRegion,
      publication: _vm.publication,
    },"lazy":""},scopedSlots:_vm._u([{key:"default",fn:function({ data }){return [_c('ControlGroup',[_c('ButtonGroup',{attrs:{"label":"Show","options":[
          { label: 'Cumulative capacity', value: 'Capacity' },
          { label: 'Net additions', value: 'Net additions' },
          { label: 'Generation', value: 'Generation' },
        ],"fixed":""},model:{value:(_vm.selectedFlow),callback:function ($$v) {_vm.selectedFlow=$$v},expression:"selectedFlow"}})],1),_c('div',{staticClass:"m-block m-block--charts m-block--charts-full"},[_c('TimeSeriesChart',{attrs:{"products":_vm.selectedFlow === 'Generation'
            ? _vm.generationProducts
            : _vm.electricityProducts,"selectedFlow":_vm.selectedFlow,"allowCaseSelection":_vm.selectedFlow !== 'Generation',"data":data,"targetText":_vm.selectedFlow === 'Capacity' && _vm.targetText ? _vm.targetText : null,"note":_vm.selectedFlow !== 'Generation'
            ? 'Generation values do not include generation associated with renewable power for hydrogen production. PV data for all countries have been unified to direct current (DC) and may differ from previous editions of this report. Because some countries\' 2030 solar PV ambitions may be based on alternating current, this may not accurately reflect the difference between 2022 total capacity and 2030 ambition capacity. Conversions are based on an IEA survey of more than 80 countries and interviews with PV industry associations.'
            : null,"is-world":_vm.selectedRegion === 'World'}})],1),_c('div',{staticClass:"m-block m-block--charts m-block--charts-half"},[_c('ProcurementChart',{attrs:{"selectedRegion":_vm.selectedRegion,"selectedProduct":"Total","apiRoute":_vm.apiRoute}}),_c('FiveYearChart',{attrs:{"title":"5-year capacity growth","selectedRegion":_vm.selectedRegion,"selectedFlow":"Net additions","products":_vm.allProducts,"allProducts":_vm.electricityProducts,"productLabel":"Generation technology","showAll":"","data":data,"note":"PV data for all countries have been unified to direct current (DC) and may differ from previous editions of this report. Conversions are based on an IEA survey of more than 80 countries and interviews with PV industry associations."}})],1)]}}])}),_c('TextContent',{attrs:{"product":"Renewable electricity","region":_vm.selectedRegion,"apiRoute":_vm.apiRoute,"publication":_vm.publication}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }